import DisplayChannel from "./channeldisplay";
import EmailChannel from "./channelemail";
import OrganicChannel from "./channelorganic";
import PaidChannel from "./channelpaid";
import SocialChannel from "./channelsocial";
import {ParsedUrlParams, UrlParams} from "./urlparams";
import Referrer from "./referrer";

export enum Channel {
    Email = 'Email',
    Direct = 'Direct',
    Organic = 'Organic',
    Social = 'Social',
    Referral = 'Referral',
    Display = 'Display',
    PaidSearch = 'Paid Search',
}

export enum ChannelType {
    Other = 'Other',
    Search = 'Search',
    AI = 'AI',
}

export class ChannelGroupingResult {
    channel: Channel
    type: ChannelType

    constructor(channel: Channel, type: ChannelType) {
        this.channel = channel;
        this.type = type;
    }
}

export type MaybeChannelGroupingResult = ChannelGroupingResult | null;


export class ChannelGrouping {

    urlParams: UrlParams;
    referrer: Array<string>;
    socialPlatform: string;

    public constructor(params: UrlParams) {
        this.urlParams = params;
        this.referrer = Referrer.get();
    }

    public static get(parsed: ParsedUrlParams) : ChannelGroupingResult {
        const emailResult = EmailChannel.is(parsed);
        if (emailResult) {
            return emailResult;
        } 
        
        const displayResult = DisplayChannel.is(parsed);
        const paidResult = PaidChannel.is(parsed);
        if (displayResult) {
            return displayResult;
        } else if (paidResult) {
            return paidResult;
        }

        const referrer = Referrer.get();
        const referrerString = referrer.length === 1 ? referrer[0] : '';

        const orgResult = OrganicChannel.is(referrerString, parsed);
        if (orgResult) {
            return orgResult;
        }
        const socialResult = SocialChannel.is(referrerString, parsed);
        if (socialResult) {
            return socialResult;
        }

        if (referrerString.length > 0) {
            // non-organic, non-social referral source
            return new ChannelGroupingResult(Channel.Referral, ChannelType.Other);
        }
        // no source hints available
        return new ChannelGroupingResult(Channel.Direct, ChannelType.Other);
    }

}
